<template>
  <asc-dialog
    text="Parameter Alert"
    :show-dialog="showDialog"
    :on-close="handleClose"
    :width="850"
  >
    <template v-if="showDialog">
      <asc-parameter-alert
        :definition="definition"
        :loading="loading"
      ></asc-parameter-alert>
    </template>
  </asc-dialog>
</template>

<script>
import AscDialog from '@/components/atoms/AscDialog'
import { AscDataDefinitionMixin, AscDialogMixin } from '@/components/mixins'
import AscParameterAlert from './AscParameterAlert'

export default {
  name: 'AscParameterDefinitionDialog',

  components: {
    AscDialog,
    AscParameterAlert,
  },

  mixins: [AscDataDefinitionMixin, AscDialogMixin],
}
</script>

<style lang="scss" scoped>
.asc-dialog--container {
  display: flex;
  padding: 0;
  margin: 0;
}
</style>
